/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconEdit = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 25 25"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 25px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M22.98 2.118a3.818 3.818 0 0 1 0 5.4l-1.928 1.929-5.4-5.4 1.93-1.929a3.818 3.818 0 0 1 5.399 0z" />
        <path
          strokeLinejoin="round"
          d="M15.653 4.047l5.4 5.4-12.951 12.95L1 24.1l1.702-7.102z"
        />
      </g>
    </svg>
  ),
);
